

import {defineComponent, PropType} from "vue";

export const CopyTypeKeys = ["Normal", "Italic", "Black"]
export type CopyType =  typeof CopyTypeKeys[number]

export default defineComponent({
  name: "Copy",
  props: {
    type: {
      type: String as PropType<CopyType>,
      default: "Normal"
    }
  },
  render() {
    return (
      <span class={`copy copy--${this.$props.type}`}
      >
          {this.$slots.default?.()}
      </span>
    )
  }
})
